"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericSuccessResultToJSON = exports.GenericSuccessResultFromJSONTyped = exports.GenericSuccessResultFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function GenericSuccessResultFromJSON(json) {
    return GenericSuccessResultFromJSONTyped(json, false);
}
exports.GenericSuccessResultFromJSON = GenericSuccessResultFromJSON;
function GenericSuccessResultFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'success': json['success'],
        'errors': !(0, runtime_1.exists)(json, 'errors') ? undefined : (0, _1.MessagesFromJSON)(json['errors']),
        'warnings': !(0, runtime_1.exists)(json, 'warnings') ? undefined : (0, _1.MessagesFromJSON)(json['warnings']),
    };
}
exports.GenericSuccessResultFromJSONTyped = GenericSuccessResultFromJSONTyped;
function GenericSuccessResultToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'success': value.success,
        'errors': (0, _1.MessagesToJSON)(value.errors),
        'warnings': (0, _1.MessagesToJSON)(value.warnings),
    };
}
exports.GenericSuccessResultToJSON = GenericSuccessResultToJSON;
//# sourceMappingURL=GenericSuccessResult.js.map